import { twMerge } from "tailwind-merge";
import { PollinatorLogo } from "@shared/ui/PollinatorLogo";
import { InnerContentFrame } from "@shared/ui/InnerContentFrame";
import { Type } from "@shared/ui/Type";

type Props = {
  organizationName: string;
  isInverted: boolean;
};

export const OnboardingHeader = ({ organizationName, isInverted }: Props) => {
  return (
    <InnerContentFrame
      as="header"
      className={twMerge(
        "z-20 bg-brand-50 border-b border-brand-800 md:border-none md:justify-start md:w-full",
        isInverted && "bg-brand-800 border-brand-50 md:border-b"
      )}
      innerClassName="flex-row justify-between md:flex-col md:gap-2 md:items-start md:absolute md:top-2 md:left-2"
    >
      {isInverted ? (
        <>
          <PollinatorLogo size="sm" theme="light" />
        </>
      ) : (
        <>
          <PollinatorLogo size="sm" theme="light" className="hidden md:block" />
          <PollinatorLogo size="sm" theme="dark" className="block md:hidden" />
        </>
      )}
      <Type
        variant="h5"
        className={twMerge(
          "text-brand-800 md:text-brand-100",
          isInverted && "text-brand-100"
        )}
      >
        {organizationName}
      </Type>
    </InnerContentFrame>
  );
};

export default OnboardingHeader;
